import { connect } from 'react-redux'
import Dashboard from '../views/Dashboard'
import { listData, getMemberById,getGamesFee,listRevenue} from '../action/userAction'

function mapStateToProps (state, ownProps) {
  let members = state.getIn(['data','members']);
  let revenue = state.getIn(['data','revenue']);
  let games_fee = state.getIn(['data','games_fee']);
  return {
    members: members,
    revenue: revenue,
    games_fee: games_fee,
  };
  
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  onLoad:() =>{
    dispatch(getGamesFee());
    dispatch(listRevenue());
  },
  getData:() =>{
    dispatch(listData());
  },
  testfunction:(id)=>{
    dispatch(getMemberById(id));
  }
})

const DasboardContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard)

export default DasboardContainer